import React from 'react'
import { Chip, Typography } from '@mui/material'

export const StatusTag = ({ code, lang }) => {

    const getText = (c) => {
        switch (c) {
            case "N": return lang === "th" ? "เปิดงาน" : "Open"
            case "A": return lang === "th" ? "ตรวจสอบ" : "Reviewing"
            case "E": return lang === "th" ? "ประเมินงาน" : "Evaluating"
            case "D": return lang === "th" ? "เข้าซ่อม - ดำเนินการ" : "In Progress"
            case "C": return lang === "th" ? "เสร็จงาน (ฝ่ายช่าง)" : "Completed"
            case "P": return lang === "th" ? "ปิดงาน" : "Closed"
            default: return "N/A"
        }
    }

    const getColorFromCode = (c) => {
        switch (c) {
            case "N": return "#2F80ED"   
            case "A": return "#F2C94C"   
            case "E": return "#56CCF2"   
            case "D": return "#F2994A"   
            case "C": return "#27AE60"   
            case "P": return "#9B51E0"   
            default: return "#BDBDBD"    
        }
    }

    return (
        <Chip
            label={
                <Typography
                    fontSize={12}
                    fontWeight={700}
                    color="#FFFFFF"
                >
                    {getText(code)}
                </Typography>
            }
            sx={{
                backgroundColor: getColorFromCode(code),
                color: '#fff',
                borderRadius: '8px',
                height: 24,
                px: 1,
            }}
        />
    )
}